/**
 * Checks whether plan has no end date, meaning the user will be charged until the plan is canceled.
 * Both recurring and one time plans can be unlimited.
 * @returns true if plan is unlimited.
 */

export const isUnlimitedPlan = plan => {
  var _plan$pricing, _plan$pricing3;
  if ((_plan$pricing = plan.pricing) != null && _plan$pricing.subscription) {
    var _plan$pricing2;
    return ((_plan$pricing2 = plan.pricing) == null ? void 0 : _plan$pricing2.subscription.cycleCount) === 0;
  }
  return !!((_plan$pricing3 = plan.pricing) != null && _plan$pricing3.singlePaymentUnlimited);
};
//# sourceMappingURL=is-unlimited-plan.js.map